import { FilterType, Filter, FilterKey, EApplicantOfferPGKeys } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '..';
import { orderBy } from 'lodash';

const key = FilterKey.FEE_STATUS;
export const getFeeStatusFilter = ({ activeFilters, filterOptions }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  let feeStatusFilterOptions = filterOptions?.[EApplicantOfferPGKeys.FEE_STATUS] || [];
  if (!feeStatusFilterOptions) {
    console.warn('Fee status filter options could not be extracted from filter options.');
    feeStatusFilterOptions = [];
  }
  const options = feeStatusFilterOptions.map(feeStatus => {
    return {
      label: feeStatus.label,
      value: feeStatus.value,
      checked: filters.some(filter => filter === feeStatus.value),
    };
  });

  const sortedOptions = orderBy(options, [option => option.label.toLowerCase()], ['asc']);

  return {
    name: 'Fee Status',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: sortedOptions,
    },
  };
};
